class ProductMobileQuickAdd extends HTMLDialogElement {
  static observedAttributes = ["open"];

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
  }

  initializeElements() {
    this.elements = {
      backdrop: this.querySelector('[data-product-mobile-quick-add-el="backdrop"]'),
      dialog: this.querySelector('[data-product-mobile-quick-add-el="dialog"]'),
      closeButton: this.querySelector('[data-product-mobile-quick-add-el="close"]'),
      variantRadios: this.querySelector('[data-product-mobile-quick-add-el="variantRadios"]'),
      selectedVariantInput: this.querySelector('[data-product-mobile-quick-add-el="selectedVariantInput"]'),
      submitButton: this.querySelector('[data-product-mobile-quick-add-el="submit"]'),
      viewAllLink: this.querySelector('[data-product-mobile-quick-add-el="viewAllLink"]')
    };
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      newValue === null ? this.unlockBodyScroll() : this.lockBodyScroll();
    }
  }

  setupEventListeners() {
    this.elements.closeButton.addEventListener('click', this.handleClose.bind(this));
    this.elements.backdrop.addEventListener('click', this.handleClose.bind(this));

    if (this.elements.variantRadios) {
      this.elements.variantRadios.addEventListener('change', this.handleVariantChange.bind(this));
    }

    if (this.elements.submitButton) {
      this.elements.submitButton.addEventListener('click', this.handleSubmit.bind(this));
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    window.Moonbase.ajaxCart.handleAddToCartClick(event);
  }

  handleClose() {
    this.close();
  }

  handleVariantChange(event) {
    this.updateVariantRadios(event.target);
    this.setSelectedVariant(event.target.value);
    this.setViewAllLink(`${this.stripSearchParams(this.elements.viewAllLink.href)}?variant=${event.target.value}`);
  }

  updateVariantRadios(target) {
    this.elements.variantRadios.querySelectorAll('input').forEach((variantRadio) => {
      variantRadio.checked = variantRadio === target;
    });
  }

  setSelectedVariant(variantId) {
    this.elements.selectedVariantInput.value = variantId;
  }

  setViewAllLink(href) {
    this.elements.viewAllLink.href = href;
  }

  lockBodyScroll() {
    document.body.style.overflowY = 'hidden';
  }

  unlockBodyScroll() {
    document.body.style.overflowY = 'auto';
  }

  stripSearchParams(url) {
    const parsedUrl = new URL(url);
    parsedUrl.search = '';
    return parsedUrl.toString();
  }
}

customElements.define('product-mobile-quick-add', ProductMobileQuickAdd, { extends: 'dialog' });
